import { createGate } from "effector-react";
function FTLSmartDetailGate() {
    const ftlSmartDetailGate = createGate({});
    return ftlSmartDetailGate;
}
export default FTLSmartDetailGate;
//# sourceMappingURL=FTLSmartDetailGate.js.map